import React from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";

class MyRoute extends Route {
  constructor() {
    super(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
  }

  componentWillMount() {
    this.setState({
      component: this.props.component
    });
    const self = this;
    if (!this.props.getComponent) {
      this.setState({ component: this.props.component });
      return;
    }
    this.props.getComponent(function(Component) {
      self.setState({
        component: Component
      });
    });
  }

  render() {
    return React.createElement(this.state.component, {
      params: this.props.computedMatch.params,
      routeProps: this.props
    });
  }
}

module.exports = MyRoute;



// WEBPACK FOOTER //
// ./src/js/components/Router/Route.react.js